import { zYesno } from '@/utils';
import { z } from 'zod';
import { zLookup } from '@/utils/zodHelper';

export const CitySchema = z.object({
  id: z.number().optional(),
  name: z.string(),
  is_active: z.boolean().optional(),
  timezone: zYesno().optional(),
  country: zLookup(),
});

export const CitySearchSchema = z.object({
  search: z.string().optional(),
  is_active: zYesno().optional(),
});

export type CitySchemaType = z.infer<typeof CitySchema>;
